import { createAuthClientComposable } from '#bubba/shared/composables/auth/useAuthClient';

/**
 * Auth client for Better Auth with Convex integration.
 * Website-specific: disables refetchOnWindowFocus to prevent unnecessary
 * get-session requests from unauthenticated tab-switching visitors.
 */
export const useAuthClient = createAuthClientComposable({
  sessionOptions: { refetchOnWindowFocus: false },
});
